import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, Spacing, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowImageXlConverter extends CmsConverterService<PanelRowImageXlData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const altText = formData.st_panel_row_image_xl_alternative_text?.value
    const lazyLoad = formData.st_lazy_load_image?.value
    return {
      image: CmsConverterService.mapImage(formData.st_panel_row_image_xl_image_normal_reference, lazyLoad, altText),
      imageLarge: CmsConverterService.mapImage(formData.st_panel_row_image_large, lazyLoad, altText),
      caption: formData.st_panel_row_image_xl_caption_text_small ?? defaultTextInput,
      overlayCaption: formData.st_panel_row_image_xl_caption_text_overlay ?? defaultTextInput,
      overlayDescription: formData.st_panel_row_image_xl_description_text_overlay ?? defaultTextInput,
      spacing: {
        top: formData.st_panel_row_image_spacing_top?.value?.identifier ?? '',
        bottom: formData.st_panel_row_image_spacing_bottom?.value?.identifier ?? ''
      },
    }
  }
}

export const PANEL_ROW_IMAGE_XL_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowImageXlData>>('PanelRowImageXlConverter')

export interface PanelRowImageXlData extends ConvertedComponentData {
  image: Image;
  imageLarge: Image | undefined;
  caption: TextInput;
  overlayCaption: TextInput;
  overlayDescription: TextInput;
  spacing: Spacing;
}

